import styled from '@emotion/styled'

export const FieldContainer = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 7px;
`

export const FieldLabel = styled.label`
  color: #fff;
  font-size: 13px;
  font-weight: 500;
`

export const FieldMessage = styled.span<{ $invalid?: boolean }>`
  color: ${({ $invalid }) => ($invalid ? '#ff8e8e' : '#b7c1d3')};
  font-size: 12px;
`
